document.addEventListener('DOMContentLoaded', function () {

  // NAV SCROLL
  const nav = document.getElementById('pc-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('pc-nav--scrolled', window.scrollY > 50);
    });
  }

  // SCROLL REVEAL
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('pc-on');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.pc-reveal').forEach(el => obs.observe(el));

  // TICKER LOOP
  const track = document.querySelector('.pc-ticker-track');
  if (track) {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone;
  }

});

// Variant image switcher for Swiper gallery
document.addEventListener('DOMContentLoaded', function() {
  const variantSelects = document.querySelectorAll('select[name="id"]');
  
  variantSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      const variantId = this.value;
      const productJson = document.querySelector('[data-rv-handle]');
      if (!productJson) return;

      const allVariantData = window.productVariants || [];
      
      // Find the variant
      const forms = document.querySelectorAll('.js-product_section');
      forms.forEach(function(form) {
        const variantData = form.querySelector('[data-product-variants]');
        if (!variantData) return;
        
        try {
          const variants = JSON.parse(variantData.textContent);
          const variant = variants.find(v => v.id == variantId);
          
          if (variant && variant.featured_image) {
            const swiper = document.querySelector('#swiper-product');
            const slides = swiper ? swiper.querySelectorAll('.swiper-slide img') : [];
            
            slides.forEach(function(img, index) {
              if (img.src.includes(variant.featured_image.src.split('/').pop().split('?')[0])) {
                const swiperInstance = swiper.swiper;
                if (swiperInstance) swiperInstance.slideTo(index);
              }
            });
          }
        } catch(e) {
          console.log('Variant switch error:', e);
        }
      });
    });
  });
});
// Variant image switcher for Swiper
document.addEventListener('DOMContentLoaded', function() {
  function switchVariantImage(variant) {
    if (!variant || !variant.featured_image) return;
    
    var swiperEl = document.getElementById('swiper-product');
    if (!swiperEl || !swiperEl.swiper) return;
    
    var swiper = swiperEl.swiper;
    var variantImgFile = variant.featured_image.src.split('/').pop().split('?')[0];
    
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    slides.forEach(function(slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      var slideFile = img.src.split('/').pop().split('?')[0];
      if (slideFile === variantImgFile) {
        swiper.slideTo(i, 0);
      }
    });
  }

  // Hook into Shopify's variant change event
  document.addEventListener('variantChange', function(e) {
    console.log('variantChange event fired', e.detail);
    if (e.detail && e.detail.variant) {
      switchVariantImage(e.detail.variant);
    }
  });

  // Also hook into select change directly
  var selects = document.querySelectorAll('select[name="id"]');
  selects.forEach(function(select) {
    select.addEventListener('change', function() {
      setTimeout(function() {
        var swiperEl = document.getElementById('swiper-product');
        console.log('Select changed, swiper:', swiperEl ? 'found' : 'not found');
      }, 100);
    });
  });
});
// Override selectCallback for variant image switching
$(document).ready(function() {
  var originalSelectCallback = window.selectCallback;
  window.selectCallback = function(variant, selector) {
    if (originalSelectCallback) {
      originalSelectCallback(variant, selector);
    }
    console.log('selectCallback intercepted:', variant ? variant.id : 'null', variant ? variant.featured_image : 'no image');
    if (variant && variant.featured_image) {
      var $product = $('.product-' + selector.product.id);
      var swiperEl = $product.find('#swiper-product')[0];
      if (swiperEl && swiperEl.swiper) {
        var swiper = swiperEl.swiper;
        var variantImgFile = variant.featured_image.src.split('/').pop().split('?')[0];
        $product.find('.swiper-slide').each(function(i) {
          var img = $(this).find('img').first();
          var slideFile = img.attr('src') ? img.attr('src').split('/').pop().split('?')[0] : '';
          if (slideFile === variantImgFile) {
            swiper.slideTo(i, 0);
            return false;
          }
        });
      }
    }
  };
});
// Reinitialize zoom after variant image switch
var originalImagesLoop = window.imagesLoop;
$(document).ready(function() {
  // Watch for swiper content changes
  var swiperEl = document.getElementById('swiper-product');
  if (swiperEl) {
    var observer = new MutationObserver(function() {
      // Reinitialize fancybox on new images
      $('.js-product-gallery a, #swiper-product a[data-fancybox]').fancybox({
        width: 800,
        height: 800
      });
      console.log('Swiper content changed - reinitializing');
    });
    observer.observe(swiperEl, { childList: true });
  }
});


